import { jsx as _jsx } from "react/jsx-runtime";
import { hasMultipleCompanies } from '../../security/HasMultiCompany';
import CompanyMultiSelect from '../multiselect/CompanyMultiSelect';
export var FilterCompanyMultiSelect = function (_a) {
    var _b;
    var item = _a.item, setFilter = _a.setFilter, activeFilters = _a.activeFilters, label = _a.label, isAlwaysVisible = _a.isAlwaysVisible, enabled = _a.enabled;
    return ({
        filterItem: item,
        enabled: enabled,
        filterSelectLabel: !isAlwaysVisible ? label : undefined,
        element: hasMultipleCompanies() ? (_jsx(CompanyMultiSelect, { selection: (_b = activeFilters[item]) !== null && _b !== void 0 ? _b : [], onChange: function (value) {
                var _a;
                return setFilter((_a = {}, _a[item] = value !== null && value !== void 0 ? value : undefined, _a));
            }, placeholder: undefined })) : null,
    });
};
